import { FC } from "react";
import { useNavigate } from "react-router";
import { siteRoutes } from "@/routes/siteRoutesList";
import { Box, Button, Heading } from "@radix-ui/themes";
import i18next from "i18next";

export const PageDoesntExist: FC<{}> = ({}) => {
  const navigate = useNavigate();
  return (
    <Box>
      <Heading as="h1">{i18next.t("error.page.doesntExist")}</Heading>
      <Button variant="solid" onClick={() => navigate(siteRoutes["home"])}>
        {i18next.t("error.action.backToHome")}
      </Button>
    </Box>
  );
};
